import * as React from 'react';
import { useCallback, useState } from 'react';
import clsx from 'clsx';

import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import {
  withRef,
} from '@udecode/cn';

export const DropdownMenu = DropdownMenuPrimitive.Root;

export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

export const DropdownMenuGroup = DropdownMenuPrimitive.Group;

export const DropdownMenuPortal = DropdownMenuPrimitive.Portal;

export const DropdownMenuSub = DropdownMenuPrimitive.Sub;

export const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;



export const DropdownMenuContent = withRef(({ ...props }, ref) => (
  <DropdownMenuPrimitive.Portal>
    <DropdownMenuPrimitive.Content
      ref={ref}
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
));

export const DropdownMenuCheckboxItem = withRef(({ children, className, checked, onCheckedChange }, ref) => (
  <button
    className={clsx('button--checkmark button--popover button--unstyled', checked && 'selected', className)}
    ref={ref}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onCheckedChange();
    }}
  >
    {children}
  </button>
));

export const useOpenState = () => {
  const [open, setOpen] = useState(false);

  const onOpenChange = useCallback(
    (_value = !open) => {
      setOpen(_value);
    },
    [open],
  );

  return {
    onOpenChange,
    open,
  };
};
